import {useState} from "react";

import {PostCommandeOperationCommerciale} from "@/api/operationCommerciale";
import iconCross from "@/assets/massification/iconCross.svg";
import iconValidate from "@/assets/massification/iconValidate.svg";
import Button from "@/components/Button/Button";

interface ModaleState {
  isOpen: boolean;
  message: string | JSX.Element | JSX.Element[] | undefined;
  variant: "primary" | "validate" | "negate";
  title: string;
  close: () => void;
}

export const useRefuseOperation = (
  refresh: () => void,
): {
  handleClickRefuse: (operationId: number) => Promise<void>;
  modaleInfo: ModaleState;
  setModaleinfo: React.Dispatch<React.SetStateAction<ModaleState>>;
} => {
  const [modaleInfo, setModaleinfo] = useState<ModaleState>({
    isOpen: false,
    message: undefined,
    variant: "primary",
    title: "",
    close: () => setModaleinfo(prev => ({...prev, isOpen: false})),
  });

  const handleClickRefuse = async (operationId: number): Promise<void> => {
    const messageValidationRefuse: JSX.Element = (
      <div>
        <p>Voulez-vous vraiment refuser cette offre ?</p>
        <div className="modale-bloc--choixButtons">
          <Button
            icon={iconValidate}
            label="Oui"
            variant="validate"
            onClick={() => handleRefuse(operationId)}
          />
          <Button
            icon={iconCross}
            label="Non"
            variant="negate"
            onClick={() => setModaleinfo(prev => ({...prev, isOpen: false}))}
          />
        </div>
      </div>
    );

    setModaleinfo(prev => ({
      ...prev,
      isOpen: true,
      message: messageValidationRefuse,
      title: "Voulez-vous vraiment refuser cette offre ?",
      variant: "primary",
    }));
  };
  const handleRefuse = async (operationId: number): Promise<void> => {
    setModaleinfo(prev => ({
      ...prev,
      isOpen: true,
      message: "Envoi en cours...",
      title: "Envoi en cours",
      variant: "primary",
    }));

    try {
      const response = await PostCommandeOperationCommerciale({
        operation_id: operationId,
        statut: "Refusée",
        commentaire: "",
        montant_total: "0",
      });

      setModaleinfo(prev => ({
        ...prev,
        isOpen: true,
        message:
          "Votre refus a bien été enregistré, vous ne serez plus contacté pour cette offre.",

        title: "Refus enregistré",
        variant: "validate",
        close: async () => {
          setModaleinfo(prev => ({...prev, isOpen: false}));
          await refresh();
        },
      }));

      console.log("Réponse de l'API :", response);
    } catch (err) {
      setModaleinfo(prev => ({
        ...prev,
        isOpen: true,
        message: "Votre refus n'a pas été pris en compte",
        variant: "negate",
        title: "Une erreur s'est produite",
        close: () => {
          setModaleinfo(prev => ({...prev, isOpen: false}));
        },
      }));
    }
  };

  return {
    handleClickRefuse,

    modaleInfo,
    setModaleinfo,
  };
};
